// EmployeeLogin.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faTimes } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

import "./LoginPage.css";


import {
  generateEmployeeToken,
  getCurrentEmployee,
  loginEmployee,
  setEmployee,
} from "../services/EmployeeService";

import "./LoginPage.css";

const EmployeeLogin = ({ onBack }) => {
  const navigate = useNavigate();

  const [loginDetail, setLoginDetail] = useState({
    username: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);

  const handleChanges = (event, property) => {
    setLoginDetail({ ...loginDetail, [property]: event.target.value });
  };

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const loginFormSubmit = (event) => {
    event.preventDefault();

    const { username, password } = loginDetail;
    if (username.trim() === "" || password.trim() === "") {
      toast.warning("Please enter both username and password");
      return;
    }

generateEmployeeToken(loginDetail)
  .then((response) => {
    const token = response.token || response.data?.token;

    if (token) {
      const bearerToken = "Bearer " + token;

      loginEmployee(token); // store just the raw token

      getCurrentEmployee().then((res) => {
        const employee = res.data;
        setEmployee(employee);
        toast.success("Login successful!");
        navigate("/employee/dashboard");
      });
    } else {
      toast.error("Token not received from server!");
    }
  })
  .catch((error) => {
    if (error.response && error.response.status === 401) {
      toast.error("Invalid username or password!");
    } else {
      toast.error("Something went wrong. Please try again later.");
    }
  });
};

  return (
    <div className="login-popup">
      <div className="loginpage_login">
        <form className="form" onSubmit={loginFormSubmit}>
          <div className="login_heading">
            <p>Employee Login</p>
            <div className="login_cancel_icon">
              <FontAwesomeIcon
                className="cancel_icon_login"
                icon={faTimes}
                onClick={onBack}
              />
            </div>
          </div>

          <div className="flex-column">
            <label>Username</label>
          </div>
          <div className="inputForm">
          <input
            type="text"
            className="input"
            placeholder="Enter your username"
            id="username"
            value={loginDetail.username || ""}
            onChange={(e) => handleChanges(e, "username")}
          />
          </div>

          <div className="flex-column">
            <label>Password</label>
          </div>
          <div className="inputForm">
            <input
              className="input"
              type={showPassword ? "text" : "password"}
              placeholder="Enter your password"
              id="password"
              onChange={(e) => handleChanges(e, "password")}
            />
          </div>

          <div className="flex-row login_page_btns">
            <div className="show_password_btn">
              <input
                type="checkbox"
                style={{ marginRight: "10px" }}
                onClick={handleTogglePassword}
              />
              <label>Show Password</label>
            </div>
            <div>
              <span className="span">
                <Link className="span" to="/employee/forgot">
                  Forgot password?
                </Link>
              </span>
            </div>
          </div>

          <button className="button_submit_login">Sign In</button>
        </form>
      </div>
    </div>
  );
};

export default EmployeeLogin;
